import { Link } from "react-router-dom"
const commonSuccessMessageAttr = {
    messageTheme: 'success',
    duration: 3000
}

const openDataExports = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('open-data-exports'));
    // Close the active toast by clicking its close button
    const closeBtn = e.target.closest('.sc-toast')?.querySelector('.sc-toast-close');
    if (closeBtn) closeBtn.click();
}

export const SUCCESS_MESSAGES = {
    "export": {
        ...commonSuccessMessageAttr,
        message: <div style={{color: 'white'}}>Your export is in progress and will be ready shortly. Once ready, you can download it from the <span className="text_link" style={{cursor: 'pointer'}} onClick={openDataExports}>Data Exports</span> page, and we'll also email you.</div>
    },
    "add_prospect": {
        ...commonSuccessMessageAttr,
        message: (redirect_url) => (
            <div>
                Prospect added, head to the prospect's{' '}
                <Link className="text_link hover_under_line" to={redirect_url}>
                Profile Page
                </Link>{' '}
                to enter additional details.
            </div>
        )
    },
    "copied": {
        ...commonSuccessMessageAttr,
        message: <div>Copied</div>
    },
    "share_data": {
        ...commonSuccessMessageAttr,
        message: <div>Thanks for sharing your data. Our team will review and process it shortly. You’ll get an update once the prospects have been added.</div>
    }
}

export const GENERIC_ERROR = 'Something went wrong. Please try again.'

export const WARNING_MESSAGES = {
    "export": {
        message: <div>You currently have 5 export requests in progress. Please wait for one to complete before starting a new export. You can check their status on the <span className="text_link" style={{cursor: 'pointer'}} onClick={openDataExports}>Data Exports</span> page.</div>
    }
}